<template>
  <Dialog
    custom-class="pg-dialog-select-model pg-dialog"
    top=""
    :showClose="showClose"
    :closeOnClickModal="closeOnClickModal"
    :closeOnPressEscape="closeOnPressEscape"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
  >
    <div class="pg-dialog-select-model__content">
      <p>{{ textTip }}</p>
      <div class="pg-dialog-select-model__list" v-if="data && data.length > 0">
        <div
          class="pg-dialog-select-model__list-item"
          v-for="(item, index) in data"
          :key="index"
          @click="chang(item)"
        >
          <i class="ivu-icon-icon-pg-Plus pg-dialog-select-model__list-item-icon"></i>
          <div class="pg-dialog-select-model__list-item-right">
            <span class="pg-dialog-select-model__list-item-right-title">{{ titleText(item) }}</span>
            <div class="pg-dialog-select-model__list-item-right-border">
              <div
                class="pg-dialog-select-model__list-item-right-border-item"
                v-for="(goodsInfo, index) in importanceInfo"
                :key="index"
              >
                <span class="pg-dialog-select-model__list-item-right-border-item-color">{{
                  goodsInfo.name
                }}</span>
                <span>{{ getValueByPath(item, goodsInfo.code) }}</span>
              </div>
            </div>
            <div class="pg-dialog-select-model__list-item-right-bottom">
              <span v-for="(ordinary, index) in ordinaryInfo" :key="index"
                >{{ ordinary.name }}：{{ getValueByPath(item, ordinary.code) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script setup>
import { Dialog } from 'element-ui'
import { useDrawerPack } from '../../../hooks/index'
import { toRefs } from 'vue'
import { getValueByPath } from '../../../utils/index'

const props = defineProps({
  showClose: {
    type: Boolean,
    default: true,
  },
  closeOnClickModal: {
    type: Boolean,
    default: true,
  },
  closeOnPressEscape: {
    type: Boolean,
    default: true,
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '请选择规格/型号',
  },
  textTip: {
    type: String,
    default: '此商品存在多个规格/型号，请选择',
  },
  width: {
    type: String,
    default: '800px',
  },
  data: Array,
  ordinaryInfo: {
    type: Array,
    default: () => {
      return [
        {
          code: 'manufacturer.name',
          name: '生产企业',
        },
        {
          code: 'brand',
          name: '品牌',
        },
        {
          code: 'origin',
          name: '产地',
        },
        {
          code: 'number',
          name: '厂家物料编码',
        },
        {
          code: 'insurance',
          name: '医保编码',
        },
      ]
    },
  },
  importanceInfo: {
    type: Array,
    default: () => {
      return [
        {
          code: 'code',
          name: '商品编码',
        },
        {
          code: 'model',
          name: '规格型号',
        },
        {
          code: 'unit.name',
          name: '单位',
        },
      ]
    },
  },
  goodsCommonNameKey: {
    type: String,
    default: 'commonName',
  },
  goodsNameKey: {
    type: String,
    default: 'name',
  },
})

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])

const { visible } = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer } = useDrawerPack(visible, emit)
const chang = (item) => {
  closeDrawer()
  emit('on-ok', item)
}

const titleText = (item) => {
  const commonName = getValueByPath(item, props.goodsCommonNameKey)
    ? `(${getValueByPath(item, props.goodsCommonNameKey)})`
    : ''
  return `${getValueByPath(item, props.goodsNameKey)}${commonName}`
}
</script>
<style lang="scss">
@import '../style/select-model.scss';
</style>
